const headingFont = {
    fontFamily: 'var(--e-global-typography-heading-font-family), Sans-serif',
    fontWeight: 700,
    textTransform: 'uppercase',
    color: 'var(--e-global-color-text)'
};

export default {
    palette: {
        primary: {
            main: '#CD1D23'
        },
        secondary: {
            main: '#000'
        }
    },
    typography: {
        fontFamily: 'var(--e-global-typography-font-family), Sans-serif',
        h1: { ...headingFont },
        h2: { ...headingFont },
        h3: { ...headingFont },
        h4: { ...headingFont },
        h5: { ...headingFont },
        h6: { ...headingFont }
    },
    overrides: {
        MuiButton: {
            root: {
                fontWeight: 'bold'
            },
            outlinedPrimary: {
                border: 'none',
                backgroundColor: 'var(--e-global-color-primary)',
                color: 'var(--e-global-color-88b478a)',
                fontWeight: 'var(--e-global-typography-primary-font-weight)',
                borderRadius: '0',
                padding: '6px 12px',
                // boxShadow: 'inset 0 0 0 1px rgba(var(--black-rgb) / 10%)',
                '&:hover': {
                    border: 'none',
                    backgroundColor:
                        'var(--e-global-color-secondary) !important',
                    color: 'var(--e-global-color-88b478a)'
                }
            }
        },
        MuiPickersDay: {
            daySelected: {
                color: '#fff',
                backgroundColor: 'var(--e-global-color-accent)'
            },
            '&:hover': {
                color: '#fff'
            }
        },
        MuiPaper: {
            root: {
                // backgroundColor: 'var(--silver)',
                // boxShadow: 'none !important'
            }
        }
    }
};
